module.exports = __webpack_public_path__ + "static/media/img-2.635b78e8.jpg";